import { PaymentRedirect } from './redirect_types';
import { Optional } from './types';

export function popPaymentRedirect(): Optional<PaymentRedirect> {
    const url = new URL(window.location.href);

    const id = url.searchParams.get('payment-redirect');
    const data = localStorage.getItem('payment-redirect');

    localStorage.removeItem('payment-redirect');

    url.searchParams.forEach((_, key) => {
        url.searchParams.delete(key);
    });

    window.history.replaceState({}, document.title, url.toString());

    if (data != null && id != null) {
        const redirect: PaymentRedirect = JSON.parse(atob(data));
        if (redirect.id === id) {
            return redirect;
        }
    }
}

export function pushPaymentRedirect(redirect: PaymentRedirect) {
    localStorage.setItem('payment-redirect', btoa(JSON.stringify(redirect)));
}
